module.exports = __webpack_public_path__ + "static/media/sui.51360a7b.svg";